import { 
  SparklesIcon,
  PlusIcon,
  UsersIcon,
  CurrencyDollarIcon
} from "@heroicons/react/24/outline";
import { Button } from "@/components";

interface EmptyResourcesStateProps {
  onGenerateWithAI: () => void;
  onAddResource: () => void;
  isGenerating: boolean;
}

export function EmptyResourcesState({ 
  onGenerateWithAI, 
  onAddResource, 
  isGenerating 
}: EmptyResourcesStateProps) {
  return (
    <div className="text-center py-12">
      <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <UsersIcon className="w-8 h-8 text-pink-600" />
      </div>
      
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        Monte sua equipe de projeto
      </h3>
      
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        Defina os recursos necessários, funções da equipe e custos estimados para seu projeto. 
        Use IA para uma análise automática baseada na complexidade técnica.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
        <Button
          onClick={onGenerateWithAI}
          disabled={isGenerating}
          leftIcon={<SparklesIcon className="h-5 w-5" />}
          size="lg"
          className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
        >
          {isGenerating ? "Analisando projeto..." : "Gerar equipe com IA"}
        </Button>
        
        <Button
          onClick={onAddResource}
          variant="outline"
          size="lg"
          leftIcon={<PlusIcon className="h-5 w-5" />}
        >
          Criar manualmente
        </Button>
      </div>

      {/* Features Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12 max-w-3xl mx-auto">
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-2">
            <SparklesIcon className="w-5 h-5 text-blue-600" />
          </div>
          <h4 className="font-medium text-gray-900 mb-1">IA Inteligente</h4>
          <p className="text-sm text-gray-600">
            Análise automática da complexidade e sugestão de equipe ideal
          </p>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-2">
            <UsersIcon className="w-5 h-5 text-green-600" />
          </div>
          <h4 className="font-medium text-gray-900 mb-1">Múltiplas Funções</h4>
          <p className="text-sm text-gray-600">
            Desenvolvedores, designers, PMs, QA e DevOps
          </p>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-2">
            <CurrencyDollarIcon className="w-5 h-5 text-purple-600" />
          </div>
          <h4 className="font-medium text-gray-900 mb-1">Estimativas Precisas</h4>
          <p className="text-sm text-gray-600">
            Cálculo automático de horas e custos totais
          </p>
        </div>
      </div>
    </div>
  );
}